import { gql } from '@apollo/client';

export const EXPORT_SCHOOLS = gql`
  query ExportSchools($input: ExportArgs!) {
    institutions: exportSchools(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          addressee
          circuit {
            id
            name
          }
          contactPerson {
            id
            name
            lastName
          }
          country {
            id
            name
          }
          customNoFeeSchool
          district {
            id
            name
          }
          districtMunicipality {
            id
            name
          }
          educatorNumber
          emisNumber
          gisAltitude
          gisLatitude
          gisLongitude
          learnerNumber
          location {
            id
            name
          }
          name
          officeContactNumber
          officeEmailAddress
          phase {
            id
            name
          }
          postalAddress
          province {
            id
            name
          }
          quintile
          region {
            id
            name
          }
          section21
          sector {
            id
            name
          }
          specialization
          specializationGroup {
            id
            name
          }
          status
          streetAddress
          type {
            id
            name
          }

          # intervention fields
          interventions {
            programme {
              id
              name
            }
            serviceProviders {
              id
              name
            }
            id
            name
            subjects {
              id
              subjectGradeReference
            }
            focusSubjects {
              id
              name
            }
            grades {
              id
              value
            }
          }
        }
      }
    }
  }
`;
